module.exports = __webpack_public_path__ + "img/face-swap.b77110a1.svg";